// Design tokens — diselaraskan dengan Dashboard Admin (Gotrips, aksen Medium Blue #0000CD)
export const C = {
  page: "#efece0", card: "#ffffff", ink: "#141414", sub: "#8a8776", t3: "#a8a496",
  line: "#ece9dc", divider: "#e3dfd0", hoverBg: "#f4f1e6",
  blue: "#0000CD", blueSoft: "#e6e6fa", chip: "#d6f2e2", chipInk: "#189a5b",
  danger: "#dc2626", warn: "#b45309", sky: "#cfe3f0"
};
export const FONT_HEAD = "'Plus Jakarta Sans', sans-serif";
export const FONT_BODY = "'Plus Jakarta Sans', sans-serif";
